import { usersAPI } from '@/api'

export const fetchUser = async (
  id: number,
  expand: string[] = [],
): Promise<{
  status: 'success' | 'error'
  data: IUser | null
}> => {
  try {
    const res = await usersAPI.getUser({
      id: id,
      expand: expand,
    })

    return {
      status: !!res?.data ? 'success' : 'error',
      data: res?.data ?? null,
    }
  } catch (error) {
    console.error('Ошибка получения пользователя:', error)
    return { status: 'error', data: null }
  }
}

export const updateSupervisorResponsibilities = async (
  userId: number,
  resp: {
    classes_supervisor: number[]
    groups_supervisor: number[]
  },
): Promise<{
  status: 'success' | 'error'
}> => {
  try {
    const res = await usersAPI.updateSupervisorResponsibilities({
      id: userId,
      data: resp,
    })

    return {
      status: !!res?.data ? 'success' : 'error',
    }
  } catch (error) {
    console.error('Ошибка получения пользователя:', error)
    return { status: 'error' }
  }
}
